import {Andorra} from "./countries/ad";
import {UnitedArabEmirates} from "./countries/ae";
import {Afghanistan} from "./countries/af";
import {AntiguaBarbuda} from "./countries/ag";
import {Anguilla} from "./countries/ai";
import {Albania} from "./countries/al";
import {Armenia} from "./countries/am";
import {Angola} from "./countries/ao";
import {Argentina} from "./countries/ar";
import {AmericanSamoa} from "./countries/as";
import {Austria} from "./countries/at";
import {Australia} from "./countries/au";
import {Aruba} from "./countries/aw";
import {AlandIslands} from "./countries/ax";
import {Azerbaijan} from "./countries/az";
import {BosniaandHerzegovina} from "./countries/ba";
import {Barbados} from "./countries/bb";
import {Bangladesh} from "./countries/bd";
import {Belgium} from "./countries/be";
import {BurkinaFaso} from "./countries/bf";
import {Bulgaria} from "./countries/bg";
import {Bahrain} from "./countries/bh";
import {Burundi} from "./countries/bi";
import {Benin} from "./countries/bj";
import {SaintBarthelemy} from "./countries/bl";
import {Brunei} from "./countries/bn";
import {Bolivia} from "./countries/bo";
import {Bermuda} from "./countries/bm";
import {Bonaire} from "./countries/bq";
import {Brazil} from "./countries/br";
import {Bahamas} from "./countries/bs";
import {Bhutan} from "./countries/bt";
import {BouvetIsland} from "./countries/bv";
import {Botswana} from "./countries/bw";
import {Belarus} from "./countries/by";
import {Belize} from "./countries/bz";
import {Canada} from "./countries/ca";
import {CocosIslands} from "./countries/cc";
import {DemocraticRepublicofCongo} from "./countries/cd";
import {CentralAfricanRepublic} from "./countries/cf";
import {RepublicofCongo} from "./countries/cg";
import {Switzerland} from "./countries/ch";
import {IvoryCoast} from "./countries/ci";
import {CookIslands} from "./countries/ck";
import {Chile} from "./countries/cl";
import {Cameroon} from "./countries/cm";
import {China} from "./countries/cn";
import {Colombia} from "./countries/co";
import {CostaRica} from "./countries/cr";
import {Cuba} from "./countries/cu";
import {CapeVerde} from "./countries/cv";
import {Curacao} from "./countries/cw";
import {ChristmasIsland} from "./countries/cx";
import {Cyprus} from "./countries/cy";
import {CzechRepublic} from "./countries/cz";
import {Germany} from "./countries/de";
import {Djibouti} from "./countries/dj";
import {Denmark} from "./countries/dk";
import {Dominica} from "./countries/dm";
import {DominicanRepublic} from "./countries/do";
import {Algeria} from "./countries/dz";
import {Ecuador} from "./countries/ec";
import {Egypt} from "./countries/eg";
import {Estonia} from "./countries/ee";
import {WesternSahara} from "./countries/eh";
import {Eritrea} from "./countries/er";
import {Spain} from "./countries/es";
import {Ethiopia} from "./countries/et";
import {Finland} from "./countries/fi";
import {Fiji} from "./countries/fj";
import {FalklandIslands} from "./countries/fk";
import {FederatedStatesofMicronesia} from "./countries/fm";
import {FaroeIslands} from "./countries/fo";
import {France} from "./countries/fr";
import {Gabon} from "./countries/ga";
import {UnitedKingdom} from "./countries/gb";
import {Georgia} from "./countries/ge";
import {Grenada} from "./countries/gd";
import {FrenchGuiana} from "./countries/gf";
import {Guernsey} from "./countries/gg";
import {Ghana} from "./countries/gh";
import {Gibraltar} from "./countries/gi";
import {Greenland} from "./countries/gl";
import {Gambia} from "./countries/gm";
import {Guinea} from "./countries/gn";
import {Guadeloupe} from "./countries/gp";
import {EquatorialGuinea} from "./countries/gq";
import {Greece} from "./countries/gr";
import {SouthGeorgiaandSouthSandwichIslands} from "./countries/gs";
import {Guatemala} from "./countries/gt";
import {Guam} from "./countries/gu";
import {GuineaBissau} from "./countries/gw";
import {Guyana} from "./countries/gy";
import {HongKong} from "./countries/hk";
import {HeardIslandandMcDonaldIslands} from "./countries/hm";
import {Honduras} from "./countries/hn";
import {Croatia} from "./countries/hr";
import {Haiti} from "./countries/ht";
import {Hungary} from "./countries/hu";
import {Indonesia} from "./countries/id";
import {Ireland} from "./countries/ie";
import {Israel} from "./countries/il";
import {IsleofMan} from "./countries/im";
import {India} from "./countries/in";
import {BritishIndianOceanTerritory} from "./countries/io";
import {Iraq} from "./countries/iq";
import {Iran} from "./countries/ir";
import {Iceland} from "./countries/is";
import {Italy} from "./countries/it";
import {Jersey} from "./countries/je";
import {Jamaica} from "./countries/jm";
import {Jordan} from "./countries/jo";
import {Japan} from "./countries/jp";
import {Kenya} from "./countries/ke";
import {Kyrgyzstan} from "./countries/kg";
import {Cambodia} from "./countries/kh";
import {Kiribati} from "./countries/ki";
import {Comoros} from "./countries/km";
import {SaintKittsandNevis} from "./countries/kn";
import {NorthKorea} from "./countries/kp";
import {SouthKorea} from "./countries/kr";
import {Kosovo} from "./countries/xk";
import {Kuwait} from "./countries/kw";
import {CaymanIslands} from "./countries/ky";
import {Kazakhstan} from "./countries/kz";
import {Laos} from "./countries/la";
import {Lebanon} from "./countries/lb";
import {SaintLucia} from "./countries/lc";
import {Liechtenstein} from "./countries/li";
import {SriLanka} from "./countries/lk";
import {Liberia} from "./countries/lr";
import {Lesotho} from "./countries/ls";
import {Lithuania} from "./countries/lt";
import {Luxembourg} from "./countries/lu";
import {Latvia} from "./countries/lv";
import {Libya} from "./countries/ly";
import {Morocco} from "./countries/ma";
import {Monaco} from "./countries/mc";
import {Moldova} from "./countries/md";
import {Madagascar} from "./countries/mg";
import {Montenegro} from "./countries/me";
import {SaintMartin} from "./countries/mf";
import {MarshallIslands} from "./countries/mh";
import {Macedonia} from "./countries/mk";
import {Mali} from "./countries/ml";
import {Macau} from "./countries/mo";
import {Myanmar} from "./countries/mm";
import {Mongolia} from "./countries/mn";
import {NorthernMarianaIslands} from "./countries/mp";
import {Martinique} from "./countries/mq";
import {Mauritania} from "./countries/mr";
import {Montserrat} from "./countries/ms";
import {Malta} from "./countries/mt";
import {Mauritius} from "./countries/mu";
import {Maldives} from "./countries/mv";
import {Malawi} from "./countries/mw";
import {Mexico} from "./countries/mx";
import {Malaysia} from "./countries/my";
import {Mozambique} from "./countries/mz";
import {Namibia} from "./countries/na";
import {NewCaledonia} from "./countries/nc";
import {Niger} from "./countries/ne";
import {NorfolkIsland} from "./countries/nf";
import {Nigeria} from "./countries/ng";
import {Nicaragua} from "./countries/ni";
import {Netherlands} from "./countries/nl";
import {Norway} from "./countries/no";
import {Nepal} from "./countries/np";
import {Nauru} from "./countries/nr";
import {Niue} from "./countries/nu";
import {NewZealand} from "./countries/nz";
import {Oman} from "./countries/om";
import {Panama} from "./countries/pa";
import {Peru} from "./countries/pe";
import {FrenchPolynesia} from "./countries/pf";
import {PapuaNewGuinea} from "./countries/pg";
import {Philippines} from "./countries/ph";
import {Pakistan} from "./countries/pk";
import {Poland} from "./countries/pl";
import {SaintPierre} from "./countries/pm";
import {PitcairnIslands} from "./countries/pn";
import {PuertoRico} from "./countries/pr";
import {Palestine} from "./countries/ps";
import {Portugal} from "./countries/pt";
import {Palau} from "./countries/pw";
import {Paraguay} from "./countries/py";
import {Qatar} from "./countries/qa";
import {Reunion} from "./countries/re";
import {Romania} from "./countries/ro";
import {Serbia} from "./countries/rs";
import {Russia} from "./countries/ru";
import {Rwanda} from "./countries/rw";
import {SaudiArabia} from "./countries/sa";
import {SolomonIslands} from "./countries/sb";
import {Seychelles} from "./countries/sc";
import {Sudan} from "./countries/sd";
import {Sweden} from "./countries/se";
import {Singapore} from "./countries/sg";
import {SaintHelena} from "./countries/sh";
import {Slovenia} from "./countries/si";
import {Svalbard} from "./countries/sj";
import {Slovakia} from "./countries/sk";
import {SierraLeone} from "./countries/sl";
import {SanMarino} from "./countries/sm";
import {Senegal} from "./countries/sn";
import {Somalia} from "./countries/so";
import {Suriname} from "./countries/sr";
import {SouthSudan} from "./countries/ss";
import {SaoTomeandPrincipe} from "./countries/st";
import {ElSalvador} from "./countries/sv";
import {Syria} from "./countries/sy";
import {Eswatini} from "./countries/sz";
import {TurksandCaicosIslands} from "./countries/tc";
import {Chad} from "./countries/td";
import {FrenchSouthernandAntarcticLands} from "./countries/tf";
import {Togo} from "./countries/tg";
import {Thailand} from "./countries/th";
import {Tajikistan} from "./countries/tj";
import {Tokelau} from "./countries/tk";
import {TimorLeste} from "./countries/tl";
import {Turkmenistan} from "./countries/tm";
import {Tunisia} from "./countries/tn";
import {Tonga} from "./countries/to";
import {Turkey} from "./countries/tr";
import {TrinidadandTobago} from "./countries/tt";
import {Tuvalu} from "./countries/tv";
import {Taiwan} from "./countries/tw";
import {Tanzania} from "./countries/tz";
import {Ukraine} from "./countries/ua";
import {Uganda} from "./countries/ug";
import {UnitedStates} from "./countries/us";
import {Uruguay} from "./countries/uy";
import {Uzbekistan} from "./countries/uz";
import {VaticanCity} from "./countries/va";
import {SaintVincent} from "./countries/vc";
import {Venezuela} from "./countries/ve";
import {BritishVirginIslands} from "./countries/vg";
import {USVirginIslands} from "./countries/vi";
import {Vietnam} from "./countries/vn";
import {Vanuatu} from "./countries/vu";
import {WallisandFutuna} from "./countries/wf";
import {Samoa} from "./countries/ws";
import {Yemen} from "./countries/ye";
import {Mayotte} from "./countries/yt";
import {SouthAfrica} from "./countries/za";
import {Zambia} from "./countries/zm";
import {Zimbabwe} from "./countries/zw";

export const countries = [
    Andorra,
    UnitedArabEmirates,
    Afghanistan,
    AntiguaBarbuda,
    Anguilla,
    Albania,
    Armenia,
    Angola,
    Argentina,
    AmericanSamoa,
    Austria,
    Australia,
    Aruba,
    AlandIslands,
    Azerbaijan,
    BosniaandHerzegovina,
    Barbados,
    Bangladesh,
    Belgium,
    BurkinaFaso,
    Bulgaria,
    Bahrain,
    Burundi,
    Benin,
    SaintBarthelemy,
    Brunei,
    Bolivia,
    Bermuda,
    Bonaire,
    Brazil,
    Bahamas,
    Bhutan,
    BouvetIsland,
    Botswana,
    Belarus,
    Belize,
    Canada,
    CocosIslands,
    DemocraticRepublicofCongo,
    CentralAfricanRepublic,
    RepublicofCongo,
    Switzerland,
    IvoryCoast,
    CookIslands,
    Chile,
    Cameroon,
    China,
    Colombia,
    CostaRica,
    Cuba,
    CapeVerde,
    Curacao,
    ChristmasIsland,
    Cyprus,
    CzechRepublic,
    Germany,
    Djibouti,
    Denmark,
    Dominica,
    DominicanRepublic,
    Algeria,
    Ecuador,
    Egypt,
    Estonia,
    WesternSahara,
    Eritrea,
    Spain,
    Ethiopia,
    Finland,
    Fiji,
    FalklandIslands,
    FederatedStatesofMicronesia,
    FaroeIslands,
    France,
    Gabon,
    UnitedKingdom,
    Georgia,
    Grenada,
    FrenchGuiana,
    Guernsey,
    Ghana,
    Gibraltar,
    Greenland,
    Gambia,
    Guinea,
    // GloriosoIslands,
    Guadeloupe,
    EquatorialGuinea,
    Greece,
    SouthGeorgiaandSouthSandwichIslands,
    Guatemala,
    Guam,
    GuineaBissau,
    Guyana,
    HongKong,
    HeardIslandandMcDonaldIslands,
    Honduras,
    Croatia,
    Haiti,
    Hungary,
    Indonesia,
    Ireland,
    Israel,
    IsleofMan,
    India,
    BritishIndianOceanTerritory,
    Iraq,
    Iran,
    Iceland,
    Italy,
    Jersey,
    Jamaica,
    Jordan,
    Japan,
    Kenya,
    Kyrgyzstan,
    Cambodia,
    Kiribati,
    Comoros,
    SaintKittsandNevis,
    NorthKorea,
    SouthKorea,
    Kosovo,
    Kuwait,
    CaymanIslands,
    Kazakhstan,
    Laos,
    Lebanon,
    SaintLucia,
    Liechtenstein,
    SriLanka,
    Liberia,
    Lesotho,
    Lithuania,
    Luxembourg,
    Latvia,
    Libya,
    Morocco,
    Monaco,
    Moldova,
    Madagascar,
    Montenegro,
    MarshallIslands,
    Macedonia,
    Mali,
    Macau,
    Myanmar,
    Mongolia,
    NorthernMarianaIslands,
    Martinique,
    Mauritania,
    Montserrat,
    Malta,
    Mauritius,
    Maldives,
    Malawi,
    Mexico,
    Malaysia,
    Mozambique,
    Namibia,
    NewCaledonia,
    Niger,
    NorfolkIsland,
    Nigeria,
    Nicaragua,
    Netherlands,
    Norway,
    Nepal,
    Nauru,
    Niue,
    NewZealand,
    Oman,
    Panama,
    Peru,
    FrenchPolynesia,
    PapuaNewGuinea,
    Philippines,
    Pakistan,
    Poland,
    SaintPierre,
    PitcairnIslands,
    PuertoRico,
    Palestine,
    Portugal,
    Palau,
    Paraguay,
    Qatar,
    Reunion,
    Romania,
    Serbia,
    Russia,
    Rwanda,
    SaudiArabia,
    SolomonIslands,
    Seychelles,
    Sudan,
    Sweden,
    Singapore,
    SaintHelena,
    Slovenia,
    Svalbard,
    Slovakia,
    SierraLeone,
    SanMarino,
    Senegal,
    Somalia,
    Suriname,
    SouthSudan,
    SaoTomeandPrincipe,
    ElSalvador,
    SaintMartin,
    Syria,
    Eswatini,
    TurksandCaicosIslands,
    Chad,
    FrenchSouthernandAntarcticLands,
    Togo,
    Thailand,
    Tajikistan,
    Tokelau,
    TimorLeste,
    Turkmenistan,
    Tunisia,
    Tonga,
    Turkey,
    TrinidadandTobago,
    Tuvalu,
    Taiwan,
    Tanzania,
    Ukraine,
    Uganda,
    UnitedStates,
    Uruguay,
    Uzbekistan,
    VaticanCity,
    SaintVincent,
    Venezuela,
    BritishVirginIslands,
    USVirginIslands,
    Vietnam,
    Vanuatu,
    WallisandFutuna,
    Samoa,
    Yemen,
    Mayotte,
    SouthAfrica,
    Zambia,
    Zimbabwe,
]